import { PathBuilder, routeManager } from '@lib/route-manager';
import {
  Assignment,
  AssignmentProps,
  AssignmentSummary,
  getAssignmentTypeName,
} from '@module/assignment';

export function buildAssignmentDetailUrl(
  assignment: Assignment<AssignmentProps> | AssignmentSummary,
) {
  return buildAssignmentReferenceUrl(
    assignment.id.toString(),
    assignment.title,
    assignment.type.id.toString(),
  );
}

export function buildAssignmentReferenceUrl(id: string, title: string, typeId: string) {
  const redirectUrl = new PathBuilder()
    .withBasePath(
      routeManager.standard.testMaker.fullPath.assignment.detail.pathParams(
        id,
        getAssignmentTypeName(typeId).toLowerCase(),
      ).path,
    )
    .withQueryParam('name', title)
    .withQueryParam('level', '2')
    .build();
  return redirectUrl;
}

export function buildAssignmentReportDetailUrl(
  assignment: Assignment<AssignmentProps> | AssignmentSummary,
) {
  const reportUrl = new PathBuilder()
    .withBasePath(
      routeManager.standard.testMaker.fullPath.assignment.detail.pathParams(
        assignment.id.toString(),
        getAssignmentTypeName(assignment.type.id.toString()).toLowerCase(),
      ).path,
    )
    .withQueryParam('menu', 'report')
    .withQueryParam('level', '2')
    .withQueryParam('name', assignment.title)
    .build();
  return reportUrl;
}

export function buildAssignmentGradingUrl(
  assignment: Assignment<AssignmentProps> | AssignmentSummary,
  attendeeId: string,
) {
  const url = new PathBuilder()
    .withBasePath(
      routeManager.standard.testMaker.fullPath.assignment.detail.pathParams(
        assignment.id.toString(),
        getAssignmentTypeName(assignment.type.id.toString()).toLowerCase(),
      ).path,
    )
    .withQueryParam('menu', 'grading')
    .withQueryParam('level', '2')
    .withQueryParam('attendeeId', attendeeId)
    .withQueryParam('name', assignment.title)
    .build();
  return url;
}

export function buildAssignmentReviewUrl(assignment: Assignment<AssignmentProps>) {
  const url = routeManager.standard.testMaker.fullPath.assignment.detail.pathParams(
    assignment.id.toString(),
    getAssignmentTypeName(assignment.type.id.toString()).toLowerCase(),
  ).path;

  const reviewUrl = new PathBuilder()
    .withBasePath(url)
    .withQueryParam('menu', 'review')
    .withQueryParam('level', '2')
    .withQueryParam('formId', assignment.formReleaseInformation.id)
    .withQueryParam('name', assignment.title)
    .build();
  return reviewUrl;
}

export function buildAssignmentShareUrl(id: string, title: string) {
  const url = new PathBuilder()
    .withBasePath(routeManager.standard.responder.fullPath.assignment.detail.pathParams(id).path)
    .withQueryParam('level', '2')
    .withQueryParam('name', title)
    .build();
  return url;
}
